import React, {Component} from 'react';
import {Link} from 'react-router-dom'

class OrderInformationCard extends Component {
    constructor(props) {
        super(props);

    };

    render() {
        const {school}=this.props;
        return (
                <div className="pricingTable">
                    <div className="priceUper">
                        <div className="priceTitle bg-color-1"><h3>Order Information (Current Month)</h3></div>
                    </div>
                    <div className="row" style={styles.HeaderStyle}>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{textAlign: "left"}}>
                            <span>Site</span>

                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <span>Total Lunches</span>

                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <span>Free</span>

                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <span>Reduced</span>

                        </div>
                        
                    </div>
                    {
                        school.map(item=> (
                        <div className="row" style={styles.linkStyle} key={item.mealSchoolId}>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{textAlign:"left"}}>
                                <span>{item.schoolName}</span>

                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                {/* <Link to={`/district/lunchs?id=${item.mealSchoolId}`} onClick={()=>{
                                        this.props.setSelectedSchool(item.mealSchoolId)
                                    }} role="button" aria-haspopup="true" aria-expanded="false"><i
                                         aria-hidden="true"/> </Link> */}
                                         <div style={styles.linkStyle}>{((item.orders||{}).Total) || '-'}</div>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                               
                                {/* <Link to={`/district/lunchs?id=${item.mealSchoolId}&type=free`} onClick={()=>{
                                        this.props.setSelectedSchool(item.mealSchoolId)
                                    }} role="button" aria-haspopup="true" aria-expanded="false"><i
                                         aria-hidden="true"/> </Link> */}
                                         <div style={styles.linkStyle}>{((item.orders||{}).Free) || '-'}</div>

                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                {/* <Link to={`/district/lunchs?id=${item.mealSchoolId}&type=reduced`} onClick={()=>{
                                        this.props.setSelectedSchool(item.mealSchoolId)
                                    }} role="button" aria-haspopup="true" aria-expanded="false"><i
                            aria-hidden="true"/> </Link> */}
                            <div style={styles.linkStyle}>{((item.orders||{}).Reduced) || '-'}</div>

                            </div>
                           
                        </div>
                        ))
                    }
                    
                   
                </div>

        );
    }
}

const styles = {
    linkStyle: {
       
        textAlign : "center",
        marginLeft : 10,
        paddingBottom : 10,
        color:"rgb(120 120 121)"
    },
    HeaderStyle: {
        marginTop : 10,
        marginLeft:10,
        color: "red",
        marginBottom : 10,
        textAlign : "center",

    }

}

export default OrderInformationCard;




// WEBPACK FOOTER //
// ./src/components/District/Home/orderInformationCard.jsx